import { useCallback, useEffect, useState } from "react";
import {
  createEmptyReportsBundle,
  ReportsPageService,
  type ReportsDataBundle,
} from "@/services/reports-page.service";

export interface ReportsServerDataResult extends ReportsDataBundle {
  loading: boolean;
  error: unknown | null;
  refresh: () => void;
}

export function useReportsServerData(query: { enabled?: boolean }): ReportsServerDataResult {
  const [refreshToken, setRefreshToken] = useState(0);
  const [data, setData] = useState<ReportsDataBundle>(() => createEmptyReportsBundle());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!query.enabled) {
      setData(createEmptyReportsBundle());
      setLoading(false);
      setError(null);
      return () => {
        cancelled = true;
      };
    }

    setLoading(true);
    void ReportsPageService.getBundle()
      .then((result) => {
        if (cancelled) return;
        setData(result.data);
        setError(result.error);
      })
      .catch((err) => {
        if (cancelled) return;
        setData(createEmptyReportsBundle());
        setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [query.enabled, refreshToken]);

  const refresh = useCallback(() => setRefreshToken((value) => value + 1), []);

  return {
    ...data,
    loading,
    error,
    refresh,
  };
}
